import { render, staticRenderFns } from "./relatorio-cadeira.vue?vue&type=template&id=eed80320&"
import script from "./relatorio-cadeira.vue?vue&type=script&lang=js&"
export * from "./relatorio-cadeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports